import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  root: {
    width: '96%',
  },
  button: {
    color: '#f44336',
    borderColor: '#f44336',
  },
  closeButton: {
    color: '#f44336',
  },
}))

export default useStyles
